var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDplacementIntrieur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99744 44.5471V4.55936H21.9925H37.9877V44.5471",
    stroke: "#A3AED0",
    strokeWidth: 2.99908,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9926 9.55783H30.9899C32.0941 9.55783 32.9893 10.453 32.9893 11.5572V42.5478C32.9893 43.652 32.0941 44.5471 30.9899 44.5471H21.9926M21.9926 9.55783H12.9954C11.8911 9.55783 10.996 10.453 10.996 11.5572V42.5477C10.996 43.652 11.8911 44.5471 12.9954 44.5471H21.9926M21.9926 9.55783V44.5471",
    stroke: "#A3AED0",
    strokeWidth: 1.99939,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9865 21.5541L43.8195 18.8046C43.8986 18.6859 44.0731 18.6859 44.1522 18.8046L45.9852 21.5541",
    stroke: "#A3AED0",
    strokeWidth: 1.99939,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9865 28.552L43.8195 31.3015C43.8986 31.4202 44.0731 31.4202 44.1522 31.3015L45.9852 28.552",
    stroke: "#A3AED0",
    strokeWidth: 1.99939,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000610352 44.5471H47.9847",
    stroke: "#A3AED0",
    strokeWidth: 2.99908
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(-0.000610352 0.560516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDplacementIntrieur);
export default __webpack_public_path__ + "static/media/DéplacementIntérieur.2a787637b8b86c2eb68f6f37df17c496.svg";
export { ForwardRef as ReactComponent };